import { Box } from '@mui/material';
import formatCurrency from 'src/compass/shared/util/formatCurrency';
import ICasRenderCellProps from '../ICasRenderCellProps';
import getCasTableCellValue from '../getCasTableCellValue';

/*
  CasRenderCurrency to the nearest dollar. For money columns where the cents are noise rather than
  information - a grid of premiums and indemnities reads more easily without a column of ".00".
*/
export function CasRenderCurrencyDollars(props: ICasRenderCellProps) {
  const value = getCasTableCellValue(props);

  return value != null && <Box textAlign="right">{formatCurrency(value, 0)}</Box>;
}
